export { default } from './summary-cash-accounts-details';